// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15pHY","inner":"Footer_inner__1k1I4"};